var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"min-height":"70vh"}},[_c('LeadsList',{attrs:{"showAsPartnerList":true,"leadsForPartner":_vm.leadsForPartner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }